<template>
    <TableWrapper tableContainerId="evaluations_table">

        <template v-slot:tableHead>
            <TableEvalsHead @onSort="handleSortData"/>
        </template>

        <template v-slot:tableBody>
            <TableEvalsRow
                v-for="(evaluation, index) in evalsList"
                :index="index"
                :key="evaluation.id"
                :evaluation="evaluation"
                @evaluationDeleted="showDeletedNotif"
                @notifSended="showNotif"/>
        </template>

        <template v-slot:tableHelpers>



            <transition name="notif-slide-up">
                <alert v-if="showEmailSendedNotif" context="success" @close="showEmailSendedNotif=false">
                    {{ $t('modules.evaluations.index.evalsList.alertSendEval') }}
                </alert>
            </transition>

            <transition name="notif-slide-up">
                <alert v-if="showEvalDeletedNotif" context="success" @close="showEvalDeletedNotif=false">
                    {{ $t('modules.evaluations.index.evalsList.alertDeleteEval') }}
                </alert>
            </transition>
        </template>

    </TableWrapper>

</template>

<script>
import AddToPositionModal from './addToPositionModal'
import TableEvalsHead from './tableEvalsHead'
import TableEvalsRow from './tableEvalsRow'

export default {
    name: 'TableEvals',
    components: {
        AddToPositionModal,
        TableEvalsHead,
        TableEvalsRow
    },
    data(){
        return {
            showEmailSendedNotif: false,
            showEvalDeletedNotif: false,
            sortableData: {name: 'created_at', type: 'desc'},
        }
    },
    computed: {
        evalsList(){
            return this.$store.state.EvalStore.evalsList

        //     if(this.sortableData.name == 'candidate_username' ){
        //         return this._.orderBy(this.$store.state.EvalStore.evalsList, [evaluation => evaluation.candidate_username.toLowerCase()], [this.sortableData.type])
        //     }else if(this.sortableData.name == 'sight_group_name' ){
        //         return this._.orderBy(this.$store.state.EvalStore.evalsList, [(evaluation) => {
        //             return evaluation.sight_group_name ? evaluation.sight_group_name.toLowerCase() : ''
        //         }], [this.sortableData.type])
        //    }else{
        //         return this._.orderBy(this.$store.state.EvalStore.evalsList, [this.sortableData.name], [this.sortableData.type])
        //    }
        }
    },
    methods: {
        showNotif(){
            this.showEmailSendedNotif = true
        },
        showDeletedNotif(){
            this.showEvalDeletedNotif = true
        },
        handleSortData(sortName, sortType){
            // this.sortableData = {name: sortName, type: sortType}
            const data = {
                sort_column: sortName,
                sort_type: sortType
            }
            this.$store.dispatch('EvalStore/indexEvals', data)
        }

    }
}
</script>